// ** React Imports ** //
import React from "react";
import ReactDOM from "react-dom/client";

// ** CSS Imports ** //
import "@/index.scss";

// ** Component Imports ** //
import App from "@/App";
import { Provider } from "react-redux";
import { store, persistor } from "@/store";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { HMSRoomProvider } from "@100mslive/react-sdk";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Register Service Worker for OneSignal
if ("serviceWorker" in navigator) {
  const registration = await navigator.serviceWorker.register("/OneSignalSDK.sw.js");
  console.log("OneSignal Service Worker registered:", registration);
}

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <HelmetProvider>
          <HMSRoomProvider>
            <App />
          </HMSRoomProvider>
        </HelmetProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
